angular.module('mercury.modules.qa.menumate.cancelledsaleslines')
.controller('QaMenumateCancelledSalesLinesReportCtrl', ["$http", "reporttime", "$scope", "title", "settings", function($http, reporttime, $scope, title, settings) {
  title.set('Cancelled Sales Lines Report');

  $scope.loading = $http.get(settings.apiHost + '/r/PosQaMenumateCancelledSaleLines', {
    params: {
      startTime: reporttime.start(),
      endTime: reporttime.end()
    }
  });

  $scope.loading.then(function(response) {
    title.setSubheader(response.data.notes);
    $scope.tableData = response.data.lines;
  });
}]);
